import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CircleCheck, GateMark } from "./Icons";

const ITEMS = [
  "Negative items removed in days",
  "Funding secured once credit is clean",
  "Asset protection included",
  "30 days start to finish",
];

export const TopBar = () => (
  <div className="topbar" data-testid="top-nav">
    <motion.div className="topbar-logo" data-testid="nav-logo" initial={{ opacity: 0, x: -12 }}
      animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
      <GateMark size={20} />
      <Link to="/" className="logo-link">Iron Gate <span>Consulting</span></Link>
    </motion.div>
  </div>
);

export const Stripe = () => (
  <div className="stripe" data-testid="feature-stripe">
    <div className="stripe-inner">
      {ITEMS.map((t, i) => (
        <motion.div key={t} className="stripe-item" initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 1.1 + i * 0.1 }}>
          <CircleCheck />
          {t}
        </motion.div>
      ))}
    </div>
  </div>
);

export const SmsDisclosure = () => (
  <div className="sms-disclosure" data-testid="sms-disclosure">
    <p>By submitting your information or clicking Get Started, you agree to receive SMS messages from Iron Gate Consulting. Message and data rates may apply. Reply STOP to opt out at any time. View our <Link to="/privacy" data-testid="sms-privacy-link">Privacy Policy</Link> and <Link to="/terms" data-testid="sms-terms-link">Terms of Service</Link>.</p>
  </div>
);

export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <strong>Iron Gate Consulting</strong> &nbsp;&nbsp;U.S. Veteran Owned &amp; Operated<br />
    All information submitted is kept strictly confidential.<br />
    <Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
    <span aria-hidden="true"> &nbsp;·&nbsp; </span>
    <Link to="/terms" data-testid="footer-terms-link">Terms of Service</Link>
  </footer>
);
